/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import BJB from "../../../assets/images/sponsor/Bank_BJB_logo.png";
import LogoPemkot from "../../../assets/images/sponsor/Logo Pemkot Bandung.png";
import LogoPemprov from "../../../assets/images/sponsor/Logo Pemprov Jawa Barat.png";
import Kompas from "../../../assets/images/sponsor/kompas.png";
import LogoHydroCoco from "../../../assets/images/sponsor/logo-hydro-coco.png";
import LogoLeMinerale from "../../../assets/images/sponsor/logo-leminerale.png";
import LogoIsoplus from "../../../assets/images/sponsor/logo-isoplus.jpg";
// import LogoMandiriInHealth from "../../../assets/images/sponsor/logo-mandiri-inhealth.png";
// import LogoEntrasol from "../../../assets/images/sponsor/logo-entrasol.png";
// import LogoRexona from "../../../assets/images/sponsor/logo-rexona.jpg";
import LogoEJSport from "../../../assets/images/sponsor/logo-ejsport.png";
import LogoFitbar from "../../../assets/images/sponsor/logo-fitbar.png";
import LogoSunpride from "../../../assets/images/sponsor/logo-sunpride.png";
import LogoShokz from "../../../assets/images/sponsor/logo-shokz.png";
// import LogoNeoRheumacyl from "../../../assets/images/sponsor/logo-neorheumacyl.png";
import LogoSantika from "../../../assets/images/sponsor/logo-santika.png";
// import LogoSasanaHusada from "../../../assets/images/sponsor/logo-sasana-husada.png";
import LogoZoll from "../../../assets/images/sponsor/logo-zoll.jpg";
import LogoGojek from "../../../assets/images/sponsor/logo-gojek.png";
import LogoBYD from "../../../assets/images/sponsor/logo-byd.png";
import LogoPaceAndPlace from "../../../assets/images/sponsor/logo-pace-and-place.png";
import LogoGenerali from "../../../assets/images/sponsor/logo-generali.png";
import LogoMyPertamina from "../../../assets/images/sponsor/logo-mypertamina.png";
import LogoZinc from "../../../assets/images/sponsor/logo-zinc.png";
import LogoAzzura from "../../../assets/images/sponsor/logo-azzura.png";
import LogoCiptadent from "../../../assets/images/sponsor/logo-ciptadent.png";
import LogoPosh from "../../../assets/images/sponsor/logo-posh.png";
import LogoPilkita from "../../../assets/images/sponsor/logo-pilkita.png";
import LogoAntangin from "../../../assets/images/sponsor/logo-antangin.png";
import LogoPucukHarum from "../../../assets/images/sponsor/logo-pucuk-harum.png";
import LogoTango from "../../../assets/images/sponsor/logo-tango.png";
import LogoMurniTeguh from "../../../assets/images/sponsor/logo-murni-teguh.png";
import LogoMayapadaHospital from "../../../assets/images/sponsor/logo-mayapada-hospital.png";
import LogoBintangPhysio from "../../../assets/images/sponsor/logo-bintang-physio.png";
import LogoGarmin from "../../../assets/images/sponsor/logo-garmin.png";
import LogoTribunnews from "../../../assets/images/sponsor/logo-tribunnews.png";
import LogoArdan from "../../../assets/images/sponsor/logo-ardan.jpeg";
import LogoCeritaPelari from "../../../assets/images/sponsor/logo-cerita-pelari.png";
import LogoArco from "../../../assets/images/sponsor/logo-arco.png";
import LogoKalenderLari from "../../../assets/images/sponsor/logo-kalender-lari.png";

import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Sponsor() {
    const { t } = useTranslation();
    return (
        <div className="bg-white font-poppins uppercase py-10 overflow-x-hidden">
            <div className="hidden">
                <div className="relative container w-full mx-auto py-20 2xl:py-24 grid grid-cols-1">
                    <div className="grid md:grid-cols-3 uppercase gap-4 2xl:gap-10 py-0">
                        <div className="space-y-4 flex flex-col justify-start items-center">
                            <h2 className="text-base lg:text-xl font-normal">{t("footer.powered")}</h2>
                        </div>
                        <div className="space-y-4 flex flex-col justify-start items-center">
                            <h2 className="text-base lg:text-xl font-normal">{t("footer.manage")}</h2>
                        </div>
                        <div className="space-y-4 flex flex-col justify-start items-center">
                            <h2 className="text-base lg:text-xl font-normal">{t("footer.govt")}</h2>
                        </div>
                    </div>
                    {/* <div className="grid md:grid-cols-3 uppercase gap-4 2xl:gap-10 py-0">
                        <div className="space-y-4 flex flex-col justify-start items-center">
                            <a href="https://bankbjb.co.id/" target="_blank" rel="noreferrer">
                                <img src={BJB} alt="logo-bjb" className="w-36 xl:w-48" />
                            </a>
                        </div>
                        <div className="space-y-4 flex flex-col justify-start items-center">
                            <img src={Kompas} alt="logo-kompas" className="w-56 xl:w-64" />
                        </div>
                        <div className="space-y-4 flex flex-col justify-start items-center">
                            <div className="flex h-full items-center justify-center gap-x-8">
                                <img src={LogoPemkot} alt="logo-pemkot" className="w-20 xl:w-28 xl:pt-4" />
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
            <div className="md:block overflow-x-hidden">
                <div className="relative container w-full mx-auto py-20 2xl:py-24 grid grid-cols-1 overflow-x-hidden">
                    <div className="grid md:grid-cols-3 uppercase gap-y-16 overflow-x-hidden">
                        <div className="space-y-4 flex flex-col justify-start items-center">
                            <h2 className="text-base lg:text-xl font-normal">{t("footer.powered")}</h2>
                            <a href="https://bankbjb.co.id/" target="_blank" rel="noreferrer">
                                <img src={BJB} alt="logo-bjb" className="w-36 xl:w-48" />
                            </a>
                        </div>
                        <div className="space-y-4 flex flex-col justify-start items-center overflow-x-hidden">
                            <h2 className="text-base lg:text-xl font-normal">{t("footer.manage")}</h2>
                            <Link to="https://kompas.id/" target="_blank" rel="noreferrer">
                                <img src={Kompas} alt="logo-kompas" className="w-56 xl:w-64 pt-4 md:pt-12" />
                            </Link>
                        </div>
                        <div className="space-y-4 flex flex-col justify-start items-center">
                            <h2 className="text-base lg:text-xl font-normal">{t("footer.govt")}</h2>
                            <div className="flex h-full items-center justify-center gap-x-8">
                                <img src={LogoPemkot} alt="logo-pemkot" className="w-20 xl:w-28 xl:pt-4" />
                                <img src={LogoPemprov} alt="logo-pemprov" className="w-20 xl:w-28 xl:pt-4" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="relative container w-full mx-auto py-0 grid grid-cols-1">
                    <div className="grid md:grid-cols-4 uppercase gap-y-16">
                        <div className="space-y-4 flex flex-col justify-start items-center">
                            <h2 className="text-base lg:text-xl font-normal">{t("footer.mineral")}</h2>
                            <img src={LogoLeMinerale} alt="logo-le-minerale" className="w-44 xl:w-56" />
                        </div>
                        <div className="space-y-4 flex flex-col justify-start items-center">
                            <h2 className="text-base lg:text-xl font-normal">{t("footer.isotonic")}</h2>
                            <img src={LogoIsoplus} alt="logo-isoplus" className="w-36 xl:w-48 pt-4 md:pt-8" />
                        </div>
                        <div className="space-y-4 flex flex-col justify-start items-center">
                            <h2 className="text-base lg:text-xl font-normal">{t("footer.healthy")}</h2>
                            <img src={LogoHydroCoco} alt="logo-hydro-coco" className="w-36 xl:w-48" />
                        </div>
                        <div className="space-y-4 flex flex-col justify-start items-center">
                            <h2 className="text-base lg:text-xl font-normal">{t("footer.insurance")}</h2>
                            <img src={LogoGenerali} alt="logo-generali" className="w-36 xl:w-72 md:pt-6" />
                        </div>
                    </div>
                </div>
                <div className="relative container w-full mx-auto py-20 grid grid-cols-1 justify-center items-center">
                    <div className="grid uppercase gap-y-16">
                        <div className="space-y-4 flex flex-col justify-center items-center">
                            <h2 className="text-base lg:text-xl font-normal">{t("footer.cosponsor")}</h2>
                            <div className="grid grid-cols-2 md:grid-cols-7 items-center md:gap-x-4 justify-center">
                                <div className="flex justify-center">
                                    <img src={LogoMyPertamina} alt="logo-mypertamina" className="w-24 xl:w-40" />
                                </div>
                                <div className="flex justify-center">
                                    <img src={LogoEJSport} alt="logo-ejsport" className="w-20 xl:w-24" />
                                </div>
                                <div className="flex justify-center">
                                    <img src={LogoZinc} alt="logo-zinc" className="w-24 xl:w-32" />
                                </div>
                                <div className="flex justify-center">
                                    <img src={LogoAzzura} alt="logo-azzura" className="w-24 xl:w-32" />
                                </div>
                                <div className="flex justify-center">
                                    <img src={LogoCiptadent} alt="logo-ciptadent" className="w-24 xl:w-32" />
                                </div>
                                <div className="flex justify-center">
                                    <img src={LogoPosh} alt="logo-posh" className="w-24 xl:w-32" />
                                </div>
                                <div className="flex justify-center">
                                    <img src={LogoFitbar} alt="logo-fitbar" className="w-36" />
                                </div>
                            </div>
                            <div className="grid grid-cols-2 md:grid-cols-8 items-center md:gap-x-0 justify-center">
                                <div className="flex justify-center">
                                    <img src={LogoPilkita} alt="logo-pilkita" className="w-24 xl:w-28" />
                                </div>
                                <div className="flex justify-center">
                                    <img src={LogoAntangin} alt="logo-antangin" className="w-24 xl:w-28" />
                                </div>
                                <div className="flex justify-center">
                                    <img src={LogoPucukHarum} alt="logo-pucuk-harum" className="w-24 xl:w-24" />
                                </div>
                                <div className="flex justify-center">
                                    <img src={LogoSunpride} alt="logo-sunpride" className="w-24 xl:w-28" />
                                </div>
                                <div className="flex justify-center">
                                    <img src={LogoTango} alt="logo-tango" className="w-24 xl:w-28" />
                                </div>
                                <div className="flex justify-center">
                                    <img src={LogoSantika} alt="logo-santika" className="w-24 xl:w-32" />
                                </div>
                                <div className="flex justify-center">
                                    <img src={LogoShokz} alt="logo-shokz" className="w-36 xl:w-48" />
                                </div>
                                <div className="flex justify-center">
                                    <img src={LogoGarmin} alt="logo-garmin" className="w-36 xl:w-48" />
                                </div>
                            </div>
                            <div className="grid grid-cols-2 md:grid-cols-6 items-center md:gap-x-4 justify-center">
                                <div className="flex justify-center">
                                    <img src={LogoBYD} alt="logo-byd" className="w-24 xl:w-32" />
                                </div>
                                <div className="flex justify-center">
                                    <img src={LogoZoll} alt="logo-zoll" className="w-24 xl:w-32" />
                                </div>
                                <div className="flex justify-center">
                                    <img src={LogoMurniTeguh} alt="logo-murni-teguh" className="w-24 xl:w-28" />
                                </div>
                                <div className="flex justify-center">
                                    <img src={LogoMayapadaHospital} alt="logo-mayapada-hospital" className="w-24 xl:w-32" />
                                </div>
                                <div className="flex justify-center">
                                    <img src={LogoBintangPhysio} alt="logo-bintang-physio" className="w-20" />
                                </div>
                                <div className="flex justify-center">
                                    <img src={LogoPaceAndPlace} alt="logo-pace-and-place" className="w-24 xl:w-32" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="relative container w-full mx-auto pt-8 pb-20 grid grid-cols-1 justify-center items-center">
                    <div className="grid uppercase gap-y-16">
                        <div className="space-y-4 flex flex-col justify-center items-center">
                            <h2 className="text-base lg:text-xl font-normal">{t("footer.mediapartner")}</h2>
                            <div className="grid grid-cols-2 md:grid-cols-5 items-center md:gap-x-4 justify-center">
                                <div className="flex justify-center">
                                    <a href="https://tribunnews.com/" target="_blank" rel="noreferrer">
                                        <img src={LogoTribunnews} alt="logo-tribunnews" className="w-24 xl:w-40" />
                                    </a>
                                </div>
                                <div className="flex justify-center">
                                    <a href="https://ardanradio.com/" target="_blank" rel="noreferrer">
                                        <img src={LogoArdan} alt="logo-ardan" className="w-20 xl:w-24" />
                                    </a>
                                </div>
                                <div className="flex justify-center">
                                    <a href="https://instagram.com/ceritapelari/" target="_blank" rel="noreferrer">
                                        <img src={LogoCeritaPelari} alt="logo-cerita-pelari" className="w-24 xl:w-36" />
                                    </a>
                                </div>
                                <div className="flex justify-center">
                                    <a href="https://arco.co.id/" target="_blank" rel="noreferrer">
                                        <img src={LogoArco} alt="logo-arco" className="w-16 xl:w-16" />
                                    </a>
                                </div>
                                <div className="flex justify-center">
                                    <a href="https://instagram.com/kalenderlari/" target="_blank" rel="noreferrer">
                                        <img src={LogoKalenderLari} alt="logo-kalender-lari" className="w-24 xl:w-40" />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
